'use strict';

var fragt = fragt || {};
var novicell = novicell || {};

fragt.counterSection = fragt.counterSection || new function () {
    this.init = function () {

        var counterSections = document.querySelectorAll('.js-counter-section');

        if (counterSections.length > 0) {
            for(var i = 0; i < counterSections.length; i++) {
                var currentCounterSection = counterSections[i];

                if (novicell.visible.isVisible(currentCounterSection)) {
                    var counterNumbers = currentCounterSection.querySelectorAll('.counter-section__number');
                    
                    for(var p = 0; p < counterNumbers.length; p++) {
                        var countEnd = counterNumbers[p].getAttribute('data-number');
                        var animeCount = anime({
                            duration: 3000,
                            value: countEnd, // Animate the input value to 1000
                            targets: counterNumbers[p],
                            round: 1, // Remove decimals by rounding the value
                            easing: 'easeInOutExpo'
                        });
                    }
                }
            }
        }
    };
}();